





















































































import { JournalEntry } from "../../models/JournalEntry";
import ECommunicationType = JournalEntry.ECommunicationType;
import JournalEntryCommunicationTypeIcon from "../JournalEntryCommunicationTypeIcon";
import AttachmentsDropdown from "../partials/AttachmentsDropdown.vue";
import EntryValidationCheckbox from "./EntryValidationCheckbox.vue";
import JournalCommentStatusIndicator from "./JournalCommentStatusIndicator.vue";
import EAttachmentType = JournalEntry.EAttachmentType;
import Dropdown from "../../core/UI/Dropdown.vue";

export default {
    name: "ExternalMessage",
    components: {
        Dropdown,
        JournalCommentStatusIndicator,
        EntryValidationCheckbox,
        AttachmentsDropdown,
        JournalEntryCommunicationTypeIcon,
    },
    props: {
        entry: JournalEntry,
    },
    computed: {
        isIncoming(): boolean {
            return (
                this.entry.communication_type ===
                    ECommunicationType.incoming_direct_message ||
                this.entry.communication_type ===
                    ECommunicationType.incoming_email
            );
        },
        showContact(): boolean {
            return this.isIncoming
                ? !_.isEmpty(this.entry.creator_name)
                : !_.isEmpty(this.entry.recipient_name);
        },
    },
    methods: {
        seeMore(): boolean {
            return (
                this.entry.shortCondensedDescription != this.entry.description
            );
        },
        showEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.show_entry,
                this.entry
            );
        },
        sendNotification(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.send_notification,
                this.entry
            );
        },
        requestIntervention(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.intervention_request,
                this.entry
            );
        },
        createIntervention(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.create_intervention,
                this.entry
            );
        },
        sendEmail(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.send_email,
                this.entry
            );
        },
        deleteEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.delete_entry,
                this.entry
            );
        },
    },
};
